import { ShieldCheck, Sparkles, Zap } from "lucide-react";
import Reveal from "@/components/Reveal";

const CARDS = [
  {
    icon: ShieldCheck,
    title: "Comfort del paziente",
    text: "Ogni passo del percorso è pensato per il tuo comfort, dal primo colloquio al recupero.",
  },
  {
    icon: Sparkles,
    title: "Diverse possibilità terapeutiche",
    text: "Le opzioni più adatte a te, valutate caso per caso e spiegate con chiarezza.",
  },
  {
    icon: Zap,
    title: "Recupero rapido",
    text: "Tecniche orientate, quando appropriate, a favorire un recupero rapido.",
  },
];

const STATS = [
  { value: "30+", label: "anni di esperienza in proctologia" },
  { value: "96+", label: "pubblicazioni su riviste nazionali e internazionali" },
  { value: "Migliaia", label: "di procedure eseguite con successo" },
  { value: "Rapidi", label: "i tempi di recupero: dipendono dal trattamento e di solito sono molto rapidi" },
];

export default function Benefits() {
  return (
    <section className="relative py-28 bg-card/30 border-y hairline">
      <div className="max-w-7xl mx-auto px-6">
        <Reveal>
          <p className="eyebrow">Il percorso</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl mt-4 tracking-tight max-w-3xl">
            Perché i miei pazienti <span className="italic text-gold">tornano sereni alla propria vita</span>
          </h2>
        </Reveal>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-14">
          {CARDS.map(({ icon: Icon, title, text }, i) => (
            <Reveal key={title} delay={i * 0.08} className="h-full">
              <div className="group h-full rounded-3xl border border-white/10 bg-elevated/60 p-8 transition-all duration-500 hover:border-gold/40 hover:-translate-y-1">
                <span className="flex items-center justify-center w-12 h-12 rounded-2xl bg-gold/10 border border-gold/20 text-gold transition-colors group-hover:bg-gold group-hover:text-ink">
                  <Icon size={22} />
                </span>
                <h3 className="font-display text-2xl mt-6">{title}</h3>
                <p className="text-sm text-silver leading-relaxed mt-3">{text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mt-14">
          {STATS.map(({ value, label }, i) => (
            <Reveal key={value} delay={i * 0.08}>
              <div className="text-center sm:text-left border-t-2 border-gold/40 pt-6">
                <p className="font-display text-5xl text-gold">{value}</p>
                <p className="text-sm text-silver mt-2 leading-relaxed">{label}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
